(function () {
  function syncTabLabels(root, panels) {
    panels.forEach(function (panel) {
      var stageId = panel.getAttribute('data-panel');
      var tab = root.querySelector('[data-stage-btn="' + stageId + '"]');
      if (!tab) return;

      var title = panel.getAttribute('data-tab-title') || '';
      var subtitle = panel.getAttribute('data-tab-subtitle') || '';
      var labelEl = tab.querySelector('[data-tab-label]');
      var subEl = tab.querySelector('[data-tab-sublabel]');

      if (labelEl) {
        labelEl.textContent = title;
        if (title) labelEl.removeAttribute('hidden');
        else labelEl.setAttribute('hidden', '');
      }

      if (subEl) {
        subEl.textContent = subtitle;
        if (subtitle) subEl.removeAttribute('hidden');
        else subEl.setAttribute('hidden', '');
      }
    });
  }

  function dispatchCartEvents() {
    var cartBuildEvent;
    var cartOpenEvent;
    try {
      cartBuildEvent = new CustomEvent('cart:build');
      cartOpenEvent = new CustomEvent('cart:open');
    } catch (error) {
      cartBuildEvent = document.createEvent('CustomEvent');
      cartBuildEvent.initCustomEvent('cart:build', true, true, {});
      cartOpenEvent = document.createEvent('CustomEvent');
      cartOpenEvent.initCustomEvent('cart:open', true, true, {});
    }
    document.dispatchEvent(cartBuildEvent);
    document.dispatchEvent(cartOpenEvent);
  }

  function initScentProfile(root) {
    if (!root || root.dataset.scentProfileReady === 'true') return;
    root.dataset.scentProfileReady = 'true';

    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-stage-btn]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-panel]'));
    var silks = Array.prototype.slice.call(root.querySelectorAll('.scent-profile__silk span'));
    var marker = root.querySelector('.scent-profile__marker');

    syncTabLabels(root, panels);

    function show(stageId) {
      var activeIndex = 0;

      tabs.forEach(function (tab, index) {
        var on = tab.getAttribute('data-stage-btn') === stageId;
        tab.setAttribute('aria-selected', String(on));
        tab.tabIndex = on ? 0 : -1;
        if (on) activeIndex = index;
      });

      panels.forEach(function (panel) {
        panel.setAttribute('aria-hidden', 'true');
        panel.classList.remove('is-in');
      });

      panels.forEach(function (panel) {
        if (panel.getAttribute('data-panel') !== stageId) return;
        panel.setAttribute('aria-hidden', 'false');
        void panel.offsetWidth;
        panel.classList.add('is-in');
      });

      silks.forEach(function (silk) {
        silk.classList.toggle('is-active', silk.getAttribute('data-for') === stageId);
      });

      root.setAttribute('data-stage', stageId);
      if (marker) {
        marker.style.transform = 'translateX(' + activeIndex * 100 + '%)';
      }
    }

    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () {
        show(tab.getAttribute('data-stage-btn'));
      });

      tab.addEventListener('keydown', function (e) {
        var delta = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (!delta || !tabs.length) return;
        e.preventDefault();
        var next = (index + delta + tabs.length) % tabs.length;
        show(tabs[next].getAttribute('data-stage-btn'));
        tabs[next].focus();
      });
    });

    if (tabs.length) {
      show(tabs[0].getAttribute('data-stage-btn'));
    }

    var atcBtn = root.querySelector('[data-scent-profile-atc]');
    if (!atcBtn) return;

    var err = root.querySelector('[data-scent-profile-err]');
    var resetLabel = atcBtn.textContent;

    function setErr(msg) {
      if (!err) return;
      err.textContent = msg || '';
      err.classList.toggle('is-on', !!msg);
    }

    atcBtn.addEventListener('click', function (e) {
      e.preventDefault();
      setErr('');

      var variantId = atcBtn.getAttribute('data-variant-id');
      if (!variantId) {
        setErr('Product unavailable.');
        return;
      }

      atcBtn.disabled = true;
      atcBtn.classList.add('is-busy');
      atcBtn.textContent = 'Adding…';

      var cartRoot =
        window.Shopify && window.Shopify.routes && window.Shopify.routes.root
          ? window.Shopify.routes.root
          : '/';

      fetch(cartRoot + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          id: Number(variantId),
          quantity: 1
        })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('cart');
          return res.json();
        })
        .then(function () {
          atcBtn.classList.remove('is-busy');
          atcBtn.classList.add('is-added');
          atcBtn.textContent = 'Added to bag';
          dispatchCartEvents();
          setTimeout(function () {
            atcBtn.classList.remove('is-added');
            atcBtn.textContent = resetLabel;
            atcBtn.disabled = false;
          }, 4000);
        })
        .catch(function () {
          atcBtn.classList.remove('is-busy');
          atcBtn.disabled = false;
          atcBtn.textContent = resetLabel;
          setErr('That didn’t go through. Try again.');
        });
    });
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll('[data-scent-profile]');
    Array.prototype.forEach.call(roots, initScentProfile);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
